import { memo } from "react";
import { ConfirmatableDialog } from "ui/molecules/Dialog";
import useUnsavedChangesContext from "./useUnsavedChangesContext";

const ConfirmationDialog = () => {
    const {
        confirmationDialogProps,
        hasUnsavedChanges,
        confirmExit,
        cancelExit
    } = useUnsavedChangesContext();

    return (
        <ConfirmatableDialog
            content={[
                {
                    dialogContent: [
                        'Changes that you made are not saved, are you sure you want to quit?'
                    ],
                    actionContent: 'Yes'
                },
                {
                    dialogContent: [
                        'Changes that you made are not saved, are you sure you want to quit?'
                    ],
                    actionContent: 'Yes'
                }
            ]}
            cancelActionContentSlot='No'
            {...confirmationDialogProps}
            open={hasUnsavedChanges.withResolvers()}
            onConfirm={confirmExit}
            onCancel={cancelExit}
            checkPredicate={() => true}
        />
    );
};

export default memo(ConfirmationDialog);
